import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/loginState/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import ControlEscolarSaga from "../store/controlescolar/saga"
import CampusVirtualSaga from "../store/campusvirtual/saga"
import Caja from "../store/caja/saga"
import Credenciales from "../store/credenciales/saga"
import Documentos from "../store/documentos/saga"
import Contribuyentes from "../store/contribuyentes/saga"
import Cargos from "../store/cargos/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ControlEscolarSaga),
    fork(CampusVirtualSaga),
    fork(Caja),
    fork(Credenciales),
    fork(Documentos),
    fork(Contribuyentes),
    fork(Cargos),
  ])
}
